import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import { StudentRegistrationType } from "../Utils/Enums";

const StudentApiService = {
  registerStudent: async (data) => {
    try {
      const response = await axios.post(ApiConstants.registerStudent, {
        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,
        dateOfBirth: data.dateOfBirth,
        gender: data.gender,
        schoolName: data.schoolName,
        classId: data.class_name,
        medium: data.medium,
        email: data.email,
        mobile: data.mobile,
        addressLineOne: data.addressLineOne,
        addressLineTwo: data.addressLineTwo,
        state: data.state,
        district: data.district,
        taluka: data.taluka,
        pinCode: data.pinCode,
        registerBy: data.RegisterBy, // Add registerBy parameter
        referralCode: data.RegisterBy === StudentRegistrationType.coordinator ? data.referralCode : "", // Add referralCode parameter
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  verifyCoordinatorUniqueCode: async (uniqueCode) => {
    try {
      const response = await axios.post(
        ApiConstants.verifyCoordinatorUniqueCode,
        {
          referralCode: uniqueCode,
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  verifyOtpRegistrationStudent: async (token, otp) => {
    try {
      const response = await axios.post(
        ApiConstants.verifyOtpRegistrationStudent,
        {
          otp: otp,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default StudentApiService;
